import { render, staticRenderFns } from "./AddJob.vue?vue&type=template&id=8f0a4e18&"
import script from "./AddJob.vue?vue&type=script&lang=js&"
export * from "./AddJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports